import React, { useEffect, useState } from "react";
import DashboardLayout from "../DashboardLayout";
import apiClient from "../../utils/apiClient";
import { SearchIcon } from "lucide-react";
import { Button } from "../../components/ui/button";
import EventsCalendarTable from "./EventsCalendarTable";
import server from "../../utils/serverConfig";

export default function EventsCalendar() {
  const [data, setData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const fetchEventsCalendar = () => {
    let config = {
      method: "get",
      url: `${server.godseye.baseUrl}get-events-calendar-data`,
    };

    apiClient
      .request(config)
      .then((response) => {
        console.log("Response data-------------->", response.data);
        setData(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const updateEventsCalendar = () => {
    // Get today's date
    const today = new Date();

    // Format the date as DD-MM-YYYY
    const formatDate = (date) => {
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    };

    // Calculate the from_date and to_date
    const from_date = formatDate(today);

    // Add 3 months to today's date
    const threeMonthsLater = new Date(today);
    threeMonthsLater.setMonth(threeMonthsLater.getMonth() + 3);

    const to_date = formatDate(threeMonthsLater);

    let config = {
      method: "post",
      url: `${server.godseye.baseUrl}update-events-calendar-data`,
      params: {
        from_date: from_date,
        to_date: to_date,
      },
    };

    apiClient
      .request(config)
      .then((response) => {
        console.log("Response data-------------->", response.data);
        fetchEventsCalendar();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchEventsCalendar();
    updateEventsCalendar()
  }, []);

  // Filter data based on search query
  const filteredData = data.filter((item) =>
    item.company
      .replace(/\s+/g, "")
      .toLowerCase()
      .includes(searchQuery.replace(/\s+/g, "").toLowerCase())
  );

  return (
    <DashboardLayout>
      <div className="flex flex-col relative w-full max-h-screen">
        <div className="flex items-center justify-between space-x-4 ">
          <div className="flex items-center justify-between bg-[#0F0F0F] h-[60px] px-6 w-full">
            <p className="flex items-center text-lg font-semibold text-white">
              Events Calendar Table
            </p>
            <div className="flex items-center space-x-3 px-4">
              <div className="flex items-center space-x-1 bg-zinc-900  px-4">
                <SearchIcon className="h-5 w-5 text-white" />
                <input
                  type="text"
                  className="bg-zinc-900 text-white rounded px-4 py-3 text-sm focus:outline-none"
                  placeholder="Search by Company"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
              <Button
                varinat="outline"
                className="text-[16px] font-medium bg-zinc-800 text-white hover:bg-zinc-700"
                onClick={updateEventsCalendar}
              >
                Update Data
              </Button>
            </div>
          </div>
        </div>

        <div className="w-full h-full overflow-hidden">
          <EventsCalendarTable data={filteredData} />
        </div>
      </div>
    </DashboardLayout>
  );
}
